import { GenericFormFields } from "../../generic-form/GenericFormBody";
import { TFunction } from "i18next";
import { BulkJobsScheduleCategoryPayload } from "../../../models/job";

const createImportScheduleFields = (
  t: TFunction
): GenericFormFields<BulkJobsScheduleCategoryPayload> => {
  return {
    items: {
      tableTitle: t("schedule.costingCategories"),
      isDisabled: true,
      row: [
        {
          width: "250px",
          type: "text",
          label: t("schedule.category"),
          placeholder: t("schedule.category"),
          valueKey: "name",
          inputProps: {
            type: "text",
            required: true,
          },
        },
        {
          type: "date-picker",
          label: t("schedule.startDate"),
          placeholder: t("placeholders.startDate"),
          valueKey: "startDate",
          inputProps: {
            required: true,
          },
        },
        {
          type: "date-picker",
          label: t("schedule.endDate"),
          placeholder: t("placeholders.endDate"),
          valueKey: "endDate",
          inputProps: {
            required: true,
          },
        },
      ],
    },
  };
};

export default createImportScheduleFields;
